// extracted by mini-css-extract-plugin
export default {"page":"LG","wrapper":"MG","text":"NG","icons":"OG","icon":"PG","icon_text":"QG","carousel_wrapper":"RG","slide":"SG","image":"TG","arrows":"UG","prev":"VG","modal_root":"WG","x_mark":"XG","modal":"YG","images":"ZG","main_image":"aH","name":"bH"};
    if(module.hot) {
      // 1713211521096
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  